import { useSelector } from "../../../../../../redux/store";
import { Form, Modal } from "antd";
import { useMutation } from "react-query";
import { doc, updateDoc } from "firebase/firestore";
import { firestore } from "../../../../../../utils/firebase/setupFirebase";
import { InventedNameInput } from "./InventedNameInput";

type FormValue = { inventedName: string };
export const InventedNameModal = () => {
  const game = useSelector((state) => state.game.game);
  const gameRefUrl = useSelector((state) => state.game.gameRefUrl);
  const currentUser = useSelector((state) => state.auth.user);

  const [form] = Form.useForm();

  const userToInventName = Object.values(game?.membersMap ?? {}).find(
    (member) => member.inventedUserId === currentUser?.uid
  );

  const gameRef = doc(firestore, gameRefUrl!);

  const setInventedNameMutation = useMutation((name: string) => {
    return updateDoc(gameRef, {
      [`membersMap.${userToInventName!.userId}.inventedName`]: name,
    });
  });

  if (userToInventName?.inventedName) {
    return null;
  }
  return (
    <Modal
      closable={false}
      okText={"Abschicken"}
      onOk={() => {
        form.submit();
      }}
      okButtonProps={{
        loading: setInventedNameMutation.isLoading,
      }}
      cancelButtonProps={{ hidden: true }}
      title={`Name für ${userToInventName?.displayName}`}
      visible={true}
    >
      <Form<FormValue>
        layout={"vertical"}
        form={form}
        onFinish={(data) => {
          setInventedNameMutation.mutate(data.inventedName);
        }}
      >
        <Form.Item
          name={"inventedName"}
          rules={[
            {
              message: "Bitte gebe dir ein ausgedachten Namen ein.",
              required: true,
            },
          ]}
          label={`Welche Person / Gegenstand etc. hast du dir für ${userToInventName?.displayName} ausgedacht?`}
        >
          <InventedNameInput form={form} />
        </Form.Item>
      </Form>
    </Modal>
  );
};
